import React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const Spacing = styled('div')({
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  justifyContent: 'center'
});

export default function ModalButtons(props) {
  const {
    handleClose,
    onClick,
    isEditing,
    continueAdding,
    handleContinueAdding,
    addLabel,
    continueAddingLabel,
    intermediateAction,
    intermediateBtnLabel,
    hideContinueAdding = false,
    hideCancelBtn = false,
    hideSaveButton = false,
    saveButtonProps
  } = props;

  // used to disable btn
  const [loading, setLoading] = React.useState(false);

  const t = useAutoTranslation();

  const ContinueAddingForm = () => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            color="secondary"
            checked={continueAdding}
            onChange={handleContinueAdding}
            size="small"
            name="continueAdding"
          />
        }
        label={t(continueAddingLabel) || t('Continue adding')}
      />
    );
  };

  const saveClickHandler = (e) => {
    setLoading(true);
    onClick(e)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Grid size={12}>
        <Divider />
      </Grid>
      {!isEditing && intermediateAction && !hideContinueAdding && (
        <Grid size={12}>
          <ContinueAddingForm />
        </Grid>
      )}
      <Grid
        container
        size={12}
        sx={{
          justifyContent: 'center'
        }}
      >
        <Spacing>
          {!isEditing && !intermediateAction && !hideContinueAdding && (
            <ContinueAddingForm />
          )}
          {!hideCancelBtn && (
            <Button onClick={handleClose} variant="outlined" color="secondary">
              {t(`Cancel`)}
            </Button>
          )}

          {intermediateAction && (
            <Button
              variant="contained"
              type="button"
              color="secondary"
              onClick={intermediateAction}
            >
              {t(intermediateBtnLabel) || t('Save & Continue later')}
            </Button>
          )}
          {!hideSaveButton && (
            <Button
              onClick={saveClickHandler}
              variant="contained"
              color="secondary"
              disabled={loading}
              endIcon={loading ? <CircularProgress size={15} /> : undefined}
              {...saveButtonProps}
              type="submit"
            >
              {isEditing ? t(`Save Changes`) : t(addLabel)}
            </Button>
          )}
        </Spacing>
      </Grid>
    </>
  );
}
